module.exports = __webpack_public_path__ + "static/media/shadow-v4.0fc5b9db.svg";